import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MoneyIcon from '@material-ui/icons/Money';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));

const InfoCard = (props) => {
  const classes = useStyles();
  const { className, ...rest } = props;

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs ={12}>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              {props.title || ""}
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {props.value || <Skeleton variant="text" height={20}/>}
            </Typography>
          </Grid>
          {/* <Grid item>
            <Avatar className={classes.avatar}>
              <MoneyIcon />
            </Avatar>
          </Grid> */}
        </Grid>
        {/* <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowDownwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            {props.subValue || ""}
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            {props.subTitle || ""}
          </Typography>
        </Box> */}
      </CardContent>
    </Card>
  );
};

InfoCard.propTypes = {
  className: PropTypes.string
};

export default InfoCard;
